import { render } from "./captureSubmissionModal.vue?vue&type=template&id=6eff0b52&scoped=true"
import script from "./captureSubmissionModal.vue?vue&type=script&lang=ts"
export * from "./captureSubmissionModal.vue?vue&type=script&lang=ts"

import "./captureSubmissionModal.vue?vue&type=style&index=0&id=6eff0b52&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6eff0b52"

export default script